import type { PermissionTree } from '@/types/auth'

export function parsePermissionTree(value: unknown): PermissionTree {
  if (!value) {
    return {}
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value) as unknown
      return typeof parsed === 'object' && parsed !== null ? (parsed as PermissionTree) : {}
    } catch {
      return {}
    }
  }

  if (typeof value === 'object') {
    return value as PermissionTree
  }

  return {}
}
